import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import { Row } from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  GrantSectionHeading,
  TableLabel,
  Note,
  ItemHeading,
  SectionMediumDivider,
} from "../../style";
import { changeNoOfPayments, cancelGrantFlow } from "../../actions";
import GrantScheduleTable from "../GrantScheduleTable/GrantScheduleTable";
import FlowFooter from "../FlowFooter/FlowFooter";
import {
  ContentProvider,
  Types,
  ContentMessage,
} from "../../../../../../CommonComponents/ContentMessages";
import { validationRuleStateChecker, messageStateChecker } from "../../utils";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { SectionContent, CommonListWrapper } from "../../../../../../CommonComponents/commonStyles";

import { recGrantScheduleDerivedStates } from '../../Selectors/RecGrantScheduleSelectors';
export class RecurringGrantSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spawns: parseInt(props.noOfPayment, 10) || 0,
      error: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  formEqual = () => {
    const stateVal = {
      paymentCount: this.state.spawns,
    };
    const propsVal = {
      paymentCount: this.props.noOfPayment,
    };

    return !isEqual(stateVal, propsVal);
  };

  removeGrants = () => {
    this.props.analyticsHandler &&
      this.props.analyticsHandler(
        "remove",
        `Step 2 ${this.props.stepDesc} - Recurring Grant Schedule`,
        "Remove Grant Schedule"
      );
    this.setState((prevState) => ({
      spawns: prevState.spawns - 1,
    }));
  };

  addGrants = () => {
    this.props.analyticsHandler &&
      this.props.analyticsHandler(
        "addGrant",
        `Step 2 ${this.props.stepDesc}`,
        "Add Grant"
      );
    if (
      this.state.spawns <
      validationRuleStateChecker(this.props.frequency).lessThanValue
    ) {
      this.setState((prevState) => ({
        spawns: prevState.spawns + 1,
      }));
    } else {
      this.setState({
        error: messageStateChecker(this.props.frequency).lessThanValue,
      });
    }
  };

  closePopup = () => {
    this.setState({ error: "" });
  };

  handleSubmit = () => {
    this.props.changeNoOfPayments(this.state.spawns);
    this.props.history.push("/grants/recommend/review");
  };

  handleUpdate = () => {
    if (this.isUpdateEnabled()) {
      this.props.analyticsHandler &&
        this.props.analyticsHandler(
          "update",
          `Step 2 ${this.props.stepDesc}`,
          "Update - Recurring Grant"
        );
      this.props.changeNoOfPayments(this.state.spawns);
      this.props.onUpdate();
    } else {
      this.props.history.push("/grants/recommend/review");
    }
  };

  isUpdateEnabled = () => this.props.noOfPayment !== this.state.spawns;

  handleExit = () => {
    this.props.analyticsHandler &&
      this.props.analyticsHandler(
        "exit",
        `Step 2 ${this.props.stepDesc}`,
        "Exit - Recurring Grant"
      );
    this.props.cancelGrantFlow();
    this.props.history.push("/");
  };

  handleBack = () => {
    this.props.history.push("/grants/recommend/allocation-schedule");
  };

  render() {
    const {
      grantName,
      grantAmount,
      frequency,
      startDate,
      editMode,
      enableCancelPopUp,
    } = this.props;
    const { spawns, error } = this.state;
    return (
      <>
        <div>
          <Row className="mb-30">
            <GrantSectionHeading>Recurring grant schedule</GrantSectionHeading>
            <TableLabel>
              You can customize your dates and amounts for recurring grants only
              when a schedule turns active. You can cancel or add a payment,
              too.
            </TableLabel>
          </Row>
          <GrantScheduleTable
            grantName={grantName}
            amount={grantAmount}
            frequency={frequency}
            startDate={startDate}
            noOfPayments={spawns}
            removeSpawn={this.removeGrants}
            addSpawn={this.addGrants}
            showActions
            showFooter
          />
          <ContentProvider
            types={[Types.PAGE_DISCLAIMERS]}
            pages={["Recommend a Grant - Recurring Schedule"]}
          >
            <Note>
              <ItemHeading>Please Note</ItemHeading>
              <CommonListWrapper>
                <ContentMessage
                  page="Recommend a Grant - Recurring Schedule"
                  type={Types.PAGE_DISCLAIMERS}
                  property="field_disclaimer_content"
                  html
                />
              </CommonListWrapper>
            </Note>
          </ContentProvider>

          <SectionMediumDivider />
          <FlowFooter
            page={"Recommend a Grant"}
            keyProperty={"Cancel Recommend a Grant"}
            keyPropertyUpdate={"Cancel Recommend a Grant"}
            handlePrimaryCta={this.handleSubmit}
            handleSecondaryCta={this.handleBack}
            handleExitCta={this.handleExit}
            edit={editMode}
            enableCancelPopUp={enableCancelPopUp && this.formEqual()}
            handleUpdateCancel={this.props.onUpdateCancel}
            handleUpdateCta={this.handleUpdate}
            exitPopupTitle="Cancel grant recommendation"
          />
        </div>
        {error && (
          <ErrorPopup
            title="Alert"
            primaryCtaLabel="OK"
            primaryCta={this.closePopup}
            show
          >
            <SectionContent>{`${error}`}</SectionContent>
          </ErrorPopup>
        )}
      </>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  changeNoOfPayments: (payload) => dispatch(changeNoOfPayments(payload)),
  cancelGrantFlow: (payload) => dispatch(cancelGrantFlow(payload)),
});

const mapStateToProps = (state) => ({
  ...recGrantScheduleDerivedStates(state.toJS())
});

RecurringGrantSchedule.propTypes = {
  analyticsHandler: PropTypes.func,
  cancelGrantFlow: PropTypes.func,
  changeNoOfPayments: PropTypes.func,
  editMode: PropTypes.bool,
  enableCancelPopUp: PropTypes.bool,
  frequency: PropTypes.string,
  grantAmount: PropTypes.string,
  grantName: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  noOfPayment: PropTypes.string,
  onUpdate: PropTypes.func,
  onUpdateCancel: PropTypes.func,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  stepDesc: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecurringGrantSchedule)
);
